/*
 * � 2020 Microsoft. All rights reserved.
 */

define('CardUI/IChallengeDefinition',[
    'lodash',
    'absolute',
    'Managers/ChallengeManager'],
    function (_, Absolute, ChallengeManager) {
    "use strict";

    var IChallengeDefinition = function (challengeType, parameters, config) {
        this.initIChallengeDefinition(challengeType, parameters, config);
    };

    IChallengeDefinition.prototype.initIChallengeDefinition = function (challengeType, parameters, config) {
        this.AllowedTime = 0;
        this.AllowedMoves = 0;
        this.DealScript = null;

        this.ChallengeType = challengeType;
        this.Parameters = {};
        this.DeckSeeds = [];
        this.theme = "dailychallenge";

        this.config = config;

        _.forEach (parameters, function (value, key)
        {
            if (!this.Parameters[key.toUpperCase()])
                this.Parameters[key.toUpperCase()] = value;
        }, this);

        this.GoalDescription = this.GetGoalDescription();
        this.ShortGoalDescription = this.GetShortGoalDescription();
        this.DailyChallengeTileTitle = this.GetModeName() + ": " + this.ShortGoalDescription;
        this.ChallengeIconUrl = this.GetChallengeIconUrl();
    };

    Object.defineProperty(IChallengeDefinition.prototype, "IsStarClub", {
        get: function () {
            return _.has(this.config,'PremiumMultiplier');
        }
    });

    Object.defineProperty(IChallengeDefinition.prototype, "ChallengeName", {
        get: function () {
            return this.ShortGoalDescription;
        },
        set: function (value ) {
            this.ShortGoalDescription = value;

        }
    });

    Object.defineProperty(IChallengeDefinition.prototype, "Coins", {
        get: function () {
            return this.config.Coins;
        }
    });

    Object.defineProperty(IChallengeDefinition.prototype, "Difficulty", {
        get: function () {
            return this.config.Difficulty;
        }
    });

    Object.defineProperty(IChallengeDefinition.prototype, "DifficultyName", {
        get: function () {
            var difficultyMap = Absolute.StringManager('difficulty', null, true);
            return difficultyMap[this.config.Difficulty - 1];
        }
    });

    Object.defineProperty(IChallengeDefinition.prototype, "Theme", {
        get: function () {
            return this.theme;
        },
        set: function (value) {
            this.theme = value;
        }
    });

    Object.defineProperty(IChallengeDefinition.prototype, "Completed", {
        get: function () {
            return ChallengeManager.IsChallengeCompleted(this.config.Key);
        },
        set: function (value) {
            ChallengeManager.SetChallengeCompleted(this.config.Key, value);
        }
    });

    Object.defineProperty(IChallengeDefinition.prototype, "Played", {
        get: function () {
            return ChallengeManager.IsChallengePlayed(this.config.Key);
        },
        set: function (value) {
            ChallengeManager.SetChallengePlayed(this.config.Key, value);
        }
    });

    IChallengeDefinition.prototype.ConstructAuthority = function () {};
    IChallengeDefinition.prototype.GetGoalDescription = function () {};
    IChallengeDefinition.prototype.GetShortGoalDescription = function () {};
    IChallengeDefinition.prototype.GetModeName = function () {};
    IChallengeDefinition.prototype.GetChallengeIconUrl = function () {};    

    IChallengeDefinition.prototype.SetupOptionsForAuthority = function (authority)
    {
        if (authority.IsChallenge)
        {
            if (this.AllowedMoves > 0)
                authority.MovesAllowed = this.AllowedMoves;
            if (this.AllowedTime > 0)
                authority.StartingTime = this.AllowedTime;
            if (this.DealScript != null)
                authority.SetDealScript(this.DealScript);
            for (var i = 0; i < this.DeckSeeds.length; i++) {
                authority.DeckSeeds.push(this.DeckSeeds[i]);
            }
        }
    };

    IChallengeDefinition.prototype.ToDictionary = function ()
    {
        var retval = {};

        retval["CHDEF_ChallengeType"] = this.ChallengeType;
        retval["CHDEF_AllowedTime"] = this.AllowedTime;
        retval["CHDEF_AllowedMoves"] = this.AllowedMoves;
        //retval.Add("CHDEF_GoalDescription", this.GoalDescription);
        retval["CHDEF_ChallengeName"] = this.ChallengeName;

        //retval.Add("CHDEF_DeckSeed", this.DeckSeed);
        for (var i = 0; i < this.DeckSeeds.length; i++) {
            retval["CHDEF_DeckSeed#" + i] = this.DeckSeeds[i];
        }

        if (this.DeckSeeds.length <= 1)
        {
            retval["CHDEF_DealScript"] = this.DealScript;
        }
        else
        {
            retval["CHDEF_DeckScript"] = this.DealScript;
        }

        _.forEach (this.Parameters, function (value, key)
        {
            retval["PARAM_" + key] = value;
        });

        return retval;
    };

    IChallengeDefinition.prototype.FromDictionaryInternal = function (spec)
    {
        this.AllowedMoves = parseInt(spec["CHDEF_AllowedMoves"]);
        this.AllowedTime = parseInt(spec["CHDEF_AllowedTime"]);
        //this.GoalDescription = spec["CHDEF_GoalDescription"];
        this.ChallengeName = spec["CHDEF_ChallengeName"];

        //this.DeckSeed = spec["CHDEF_DeckSeed"];
        var i = 0;
        while (spec["CHDEF_DeckSeed#" + i])
        {
            this.DeckSeeds.push(spec["CHDEF_DeckSeed#" + i]);
            i++;
        }

        if (spec["CHDEF_DealScript"])
            this.DealScript = spec["CHDEF_DealScript"];

        this.GoalDescription = this.GetGoalDescription();
        this.ShortGoalDescription = this.GetShortGoalDescription();
        this.DailyChallengeTileTitle = this.GetModeName() + ": " + this.ShortGoalDescription;

        this.coins = parseInt(spec.coins);


    };

    IChallengeDefinition.prototype.CompleteGoalLocString = function (str)
    {
        var retval = str;

        if (this.AllowedTime > 0)
            retval += "_Time";
        if (this.AllowedMoves > 0)
            retval += "_Moves";

        return retval;
    };

    IChallengeDefinition.prototype.GetTimeFormat = function (time) {
        var td = new Date(time * 1000);

        var hours = td.getUTCHours(),
            mins = td.getUTCMinutes(),
            secs = td.getUTCSeconds();

        return (hours > 0 ? hours + ":" : "") + (hours > 0 ? "0" + mins + ":" : mins + ":") + (secs < 10 ? "0" + secs : secs);
    };

    return IChallengeDefinition;

});
